<template>
  <svg
    :viewBox="iconData.viewBox"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    class="bi-icon"
    fill="currentColor"
    v-html="iconData.inner"
  ></svg>
</template>

<script>
import { biIconData } from '@/assets/bi-icons.js'

export default {
  name: 'BIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconData() {
      return biIconData[this.icon] || { viewBox: '0 0 16 16', inner: '' }
    },
  },
}
</script>

<style scoped>
.bi-icon {
  display: inline-block;
  height: 1em;
  width: 1em;
  vertical-align: -0.125em;
  fill: currentColor;
  overflow: visible;
}
</style>
